module.exports = __webpack_public_path__ + "img/2023-2.b4d21e9a.jpg";